export namespace LocalStorageKeys {
  export const theme = 'theme';
  export const language = 'language';
  export const timezone = 'timezone';
  export const coursesViewMode = 'coursesViewMode';
}
